module.exports = __webpack_public_path__ + "static/img/logo-unicred.4204ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-unicred.png
// module id = Z+I3
// module chunks = 1